import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";

export default function MonitoramentoPrecoUnavailable({ classes }) {
  return (
    <div className={classes.unavailableCard} role="alert">
      <Typography component="h1" className={classes.unavailableTitle}>
        Não é possível fazer uma coleta no momento
      </Typography>
      <Typography component="p" className={classes.unavailableBody}>
        Não encontramos lojas e/ou produtos de referência disponíveis. Tente
        novamente mais tarde ou fale com o suporte se precisar de ajuda.
      </Typography>
    </div>
  );
}

MonitoramentoPrecoUnavailable.propTypes = {
  classes: PropTypes.object.isRequired,
};
